import { Component, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { MatSidenav } from '@angular/material/sidenav';
import { MenuService } from '../../../shared/services/menu.service';
import { AuthService } from '../../../core/services/auth.service';
import { SeoService } from '../../../core/services/seo.service';
import { nav_path } from '../../../app-routing.module';

@Component({
  selector: 'anon-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent {
  @ViewChild('sidenav') private sidenav!: MatSidenav;
  public time: string = 'Night';
  private title = "Admin page";

  isWebLandscape$: Observable<boolean> =
    this.breakpointObserver.observe(Breakpoints.WebLandscape)
      .pipe(
        map(result => result.matches),
        shareReplay()
      );

  constructor(
    private breakpointObserver: BreakpointObserver,
    public menuService: MenuService,
    public auth: AuthService,
    private seo: SeoService
    ) {
    seo.generateTags({
      title: this.title,
      description: `Anonymous Systems ${this.title}`,
      route: nav_path.admin
    });
    this.determineTime();
  }

  determineTime() {
    const today = new Date();
    const hr = today.getHours();
    if (hr < 12) this.time = `Morning`;
    else if (hr < 18) this.time = `Afternoon`;
    else this.time = `Evening`;
  }
}
